import axios from "axios";

console.log("REACT_APP_API_URL =", process.env.REACT_APP_API_URL);
console.log("API URL:", process.env.REACT_APP_API_URL);

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
    headers: {
        "Content-Type": "application/json"
    }
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");

    // Don't attach token to login requests
    if (token && config.url !== "/auth/login") {
        config.headers.Authorization = `Bearer ${token}`;
    }

    console.log("➡️ API CALL:", config.baseURL + config.url);
    return config;
});
/*
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    console.log("➡️ API CALL:", config.baseURL + config.url);
    return config;
});
*/
export default api;

